import * as React from 'react';
import * as I18n from 'i18n-js';
import track from 'react-tracking';

import { experiments, EXPERIMENT_VALUES } from '../../shared/constants';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { experimentBucket } from '@reverbdotcom/commons/dist/user_context_helpers';
import { VIEW, TrackingProps } from '@reverbdotcom/commons/dist/tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

interface IProps extends IUserContext, TrackingProps {
  otherBuyersWithListingInCartCount?: number;
  listingId: string;
  inventoryCount?: number;
  onlyTracking?: boolean;
}

const COMPONENT_NAME = 'CartNudge';

export function CartNudge(props: IProps) {
  const { otherBuyersWithListingInCartCount, user, inventoryCount } = props;
  const shouldRender = !!otherBuyersWithListingInCartCount;
  const expBucket = experimentBucket(user, experiments.ITEM_CART_NUDGE);
  const count = inventoryCount > 0 ? inventoryCount : 1;

  React.useEffect(() => {
    if (shouldRender || props.onlyTracking) {
      props.tracking.trackEvent({
        eventType: VIEW,
        mParticleView: {
          componentName: COMPONENT_NAME,
          entityId: props.listingId,
          entityType: 'Product',
          listingId: props.listingId,
          displayStyle: '',
          eventName: MParticleEventName.ComponentView,
          experiments: formatExperimentsForEventAttributes(user, [
            experiments.ITEM_CART_NUDGE,
          ]),
        },
      });
    }
  }, [props.otherBuyersWithListingInCartCount, props.onlyTracking, props.listingId, shouldRender, props.tracking, props.user]);

  if (!shouldRender || props.onlyTracking) { return null; }
  if (expBucket === EXPERIMENT_VALUES.EXP3) { return null; }
  if (expBucket === EXPERIMENT_VALUES.EXP2) { return null; }

  const classes = expBucket === EXPERIMENT_VALUES.EXP1 ?
    'listing-nudge listing-nudge--wristwatch' :
    'listing-nudge listing-nudge--trending-up';

  return (
    <div className={classes}>
      <div className="listing-nudge__icon" />
      <div className="listing-nudge__inner">
        <p className="listing-nudge__title">
          {expBucket === EXPERIMENT_VALUES.EXP1 &&
            I18n.t('discovery.cartNudge.dontMissOut')
          }
          {expBucket !== EXPERIMENT_VALUES.EXP1 &&
            I18n.t('discovery.cartNudge.predictedToSellSoon')
          }
        </p>
        <p className="listing-nudge__subtitle">
          <span className="mr-space">
            {I18n.t('discovery.cartNudge.onlyXAvailable', { count })}
          </span>
          {I18n.t('discovery.cartNudge.peopleHaveInCarts', { count: props.otherBuyersWithListingInCartCount })}
        </p>
      </div>
    </div>
  );
}

export default withUserContext<IProps>(track({ componentName: COMPONENT_NAME })(CartNudge));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/cart_nudge/cart_nudge.tsx